import React, {
  useState,
  useEffect
} from 'react';

import logo from '../assets/logo.png';

const Login = () => {

  const [form, setForm] = useState({
    email: '',
    password: ''
  });

  const [loading, setLoading] = useState(false);

  // =========================================
  // REDIRECT IF LOGGED IN
  // =========================================

  useEffect(() => {

    const token =
      localStorage.getItem('token');

    if (token) {
      window.location.href = '/';
    }

  }, []);

  // =========================================
  // HANDLE CHANGE
  // =========================================

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // =========================================
  // LOGIN
  // =========================================

  const handleLogin = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const res = await fetch(
        '/api/login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(form)
        }
      );

      const data = await res.json();

      if (!res.ok) {

        alert(data.message);

        setLoading(false);

        return;
      }

      localStorage.setItem(
        'token',
        data.token
      );

      localStorage.setItem(
        'user',
        JSON.stringify(data.user)
      );

      window.location.replace('/');

    } catch (err) {

      console.log(err);

      alert('Login failed');

    } finally {

      setLoading(false);
    }
  };

  return (

  <div className="min-h-screen w-full bg-[#F4F7FB] flex items-center justify-center relative overflow-hidden px-4">

    {/* BACKGROUND GRADIENTS */}

    <div className="absolute top-[-200px] left-[-200px] w-[500px] h-[500px] bg-indigo-500/20 blur-[120px] rounded-full"></div>

    <div className="absolute bottom-[-200px] right-[-200px] w-[450px] h-[450px] bg-violet-500/20 blur-[120px] rounded-full"></div>

    {/* LOGIN CARD */}

    <div className="relative w-full max-w-md bg-white border border-gray-100 rounded-[32px] shadow-xl p-8 overflow-hidden">

      {/* TOP ACCENT */}

      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600"></div>

      {/* LOGO */}

      <div className="flex justify-center">

        <img
          src={logo}
          alt="logo"
          className="w-44 object-contain"
        />

      </div>

      {/* TITLE */}

      <div className="text-center mt-6 mb-8">

        <h1 className="text-3xl font-bold text-gray-800">
          Welcome Back
        </h1>

        <p className="text-gray-500 mt-3 text-sm">
          Login to access your rental dashboard
        </p>

      </div>

      {/* FORM */}

      <form
        onSubmit={handleLogin}
        className="space-y-5"
      >

        {/* EMAIL */}

        <div>

          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Address
          </label>

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className="w-full bg-[#F8FAFC] border border-gray-200 rounded-2xl px-4 py-3.5 text-gray-800 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
          />

        </div>

        {/* PASSWORD */}

        <div>

          <label className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>

          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Enter your password"
            className="w-full bg-[#F8FAFC] border border-gray-200 rounded-2xl px-4 py-3.5 text-gray-800 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
          />

        </div>

        {/* BUTTON */}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 hover:opacity-95 text-white font-semibold py-3.5 rounded-2xl transition-all shadow-lg shadow-indigo-500/20"
        >

          {
            loading
              ? "Logging In..."
              : "Login"
          }

        </button>

      </form>

      {/* FOOTER */}

      <div className="mt-6 text-center">

        <p className="text-xs text-gray-400 tracking-wide">
          Rental Inventory Management System
        </p>

      </div>

    </div>

  </div>

);
};

export default Login;
